// src/pages/user/Transactions.tsx

import Transactions from "../../components/user/Transactions";

export default function TransactionsPage() {
  return (
    <div className="min-h-screen">
      <div className="max-w-5xl mx-auto">
        <Transactions />
      </div>
    </div>
  );
}